import React from 'react';

/**
 * The action, run once at a time: a call made while a previous one is still
 * running is ignored. The flag is set before the first await, so a double
 * click or a second Enter press cannot start a second run.
 */
export function useSingleFlight(
    action: () => Promise<void>
): () => Promise<void> {
    const running = React.useRef(false);
    return async () => {
        if (running.current) {
            return;
        }
        running.current = true;
        try {
            await action();
        } finally {
            running.current = false;
        }
    };
}
